<template>

<layout>
  <template v-slot:body>
    <div class="wrap">
      <div class="video-wrap">
        <video
          class="video"
          ref="video"
          webkit-playsinline="true"
          playsinline="true"
          autoplay="true"
          muted="muted"
          loop
        >
          <source src="/video/smartTV/Nazivin.mp4" type="video/mp4">
        </video>
        <div class="video-tv"></div>
      </div>
    </div>
  </template>
</layout>

</template>

<script>
import layout from '@/components/layout.vue';

export default {
  name: 'SmartTV',
  components: {
    layout,
  },
};
</script>

<style scoped lang='stylus'>

hover()
  @media (hover: hover)
    {block}

.wrap
  position fixed
  left 360px
  top 0
  width calc(100% - 360px)
  height 100%
  pointer-events none
  .layout_mobile &
    left 0
    width 100%
    z-index 9999999999

.video
  display block
  width 100%
  height auto
  position relative
  border 6px solid black
  border-radius 1%
  box-sizing border-box
  z-index 10
  &-wrap
    position absolute
    top 50%
    left 50%
    transform translateY(-50%) translateX(-50%)
    width 80%
    max-width 1000px
    background-color black
    border-radius 4px
    &:before
      content ""
      position absolute
      width 10%
      height 10%
      background-color black
      border-radius 30%
      left 45%
      bottom -1%
      z-index 0
  // &-tv
  //   position absolute
  //   top -1%
  //   left -15%
  //   width 130%
  //   height 107%
  //   background-image url('~@/assets/tv.png')
  //   background-size contain
  //   background-position center 15%
  //   background-repeat no-repeat
  //   z-index 99999999


</style>
